import * as Yup from 'yup';
import createNovedadFormModel from './createNovedadTurnoFormModel';

const {
  formField: {
    colaborador,
    responsable,
    tipoNovedad,
    fechaNovedad,
    horaNovedad,
    description
  }

} = createNovedadFormModel;


export default [

  Yup.object().shape({ 

    [colaborador.name]: Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${colaborador.requiredErrorMsg}`),
    [responsable.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${responsable.requiredErrorMsg}`),
    [tipoNovedad.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${tipoNovedad.requiredErrorMsg}`),
    [fechaNovedad.name]: Yup.string().required(`${fechaNovedad.requiredErrorMsg}`),
    [horaNovedad.name]: Yup.string().required(`${horaNovedad.requiredErrorMsg}`),
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),


  })
  
];  

    